import { render, staticRenderFns } from "./orderCloseTip.vue?vue&type=template&id=98e64e52&"
import script from "./orderCloseTip.vue?vue&type=script&lang=js&"
export * from "./orderCloseTip.vue?vue&type=script&lang=js&"
import style0 from "./orderCloseTip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports